var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntermodalArrowsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59 7.17L3.41 2L2 3.41L7.17 8.58L8.59 7.17ZM12.5 2L14.54 4.04L2 16.59L3.41 18L15.96 5.46L18 7.5V2H12.5ZM12.83 11.41L11.42 12.82L14.55 15.95L12.5 18H18V12.5L15.96 14.54L12.83 11.41Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermodalArrowsFilled);
export default __webpack_public_path__ + "static/media/intermodal-arrows-filled.3666b0df.svg";
export { ForwardRef as ReactComponent };